import systemAdmin from './systemAdmin';

export default {
	systemAdminPage: systemAdmin
}